import { MEDIA_TYPE } from '../../../../../../../../Google/AdForms/fields'
import {
  CALL_TO_ACTION,
  CLICK_THROUGH_LINK,
  DESCRIPTION_ENTER,
  DESCRIPTION_OPTION,
  DESCRIPTIONS_LIST,
  HEADLINE_ENTER,
  HEADLINE_OPTION,
  HEADLINES_LIST
} from '../../../../../../fields'
import { IMAGE_HASH, FILE_ID, VIDEO_PICTURE } from '../../../../../../../../ReusableFormFields/AdFileUpload/fields'
import { CarouselItems } from './types'

export const formatChildAttachments = (items: CarouselItems) => {
  return items.map(item => {
    const {
      [MEDIA_TYPE]: mediaType,
      [HEADLINES_LIST]: headlinesList,
      [DESCRIPTIONS_LIST]: descriptionsList,
      [FILE_ID]: feedVideoId,
      [CLICK_THROUGH_LINK]: clickThroughLink,
      [IMAGE_HASH]: fileHash,
      [CALL_TO_ACTION]: callToActionChoice,
      [VIDEO_PICTURE]: videoPicture
    } = item

    // We support list of headlines and descriptions for custom ad, up to 5 items
    // For NOT custom ad we use 0 element from description and headline list
    const adHeadline = headlinesList?.[0].text
    const adDescription = descriptionsList?.[0].text

    const headlineEnter = item[HEADLINE_OPTION] === HEADLINE_ENTER
    const descriptionEnter = item[DESCRIPTION_OPTION] === DESCRIPTION_ENTER

    return {
      ...(mediaType === 'video' && { video_id: feedVideoId }),
      // todo remove this conditional and place fields separately
      ...(videoPicture ? { image_url: videoPicture } : { image_hash: fileHash }),
      ...(headlineEnter && { name: adHeadline }),
      ...(descriptionEnter && { description: adDescription }),
      link: clickThroughLink,
      call_to_action: {
        type: callToActionChoice.toLowerCase(),
        value: {
          link: clickThroughLink
        }
      }
    }
  })
}
